export const GOOGLE_ANALYTICS = "209051636-1";

export const SENTRY_DSN = "https://079f3a1aa7f3437dbaf0d121f2f0e0ff@o947395.ingest.sentry.io/5896774";
